export const nodeEnvironment = (process.env.NODE_ENV as 'development' | 'production' | undefined) || 'development'
export const dev = nodeEnvironment !== 'production'
